import styled from 'styled-components';

export const SuggestionsList = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10%;
  background-color: ${({ theme }) => theme.colors.cardBackground};
  border-radius: ${({ theme }) => theme.borderRadius.normal};
  box-shadow: ${({ theme }) => `0 0 10px 0 ${theme.colors.shadow}`};
  margin-bottom: 10px;
  max-height: 250px;
  overflow-y: auto;
  z-index: 1000;
`;

export const SuggestionItem = styled.div`
  padding: 12px;
  cursor: pointer;
  border-bottom: ${(props) => (props.isLast ? 'none' : '1px solid #eee')};
  transition: background-color 0.2s;
  font-size: ${({ theme }) => theme.fontSizes.normal};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${({ theme }) => theme.fontSizes.small};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverBackground};
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  font-size: ${({ theme }) => theme.fontSizes.normal};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${({ theme }) => theme.fontSizes.small};
  }
`;
